<div>
    <div style="margin-left: 80%; margin-bottom: 2%">
        <button class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
            printTitle="Label" printSectionId="print" ngxPrint [useExistingCss]="true">
            print
        </button>
        <button mat-dialog-close class="btn noPrint" (click)="close()">Close</button>
    </div>

    <div class="mt-3" id="print">
        <div class="invoice-container" *ngFor="let data of amounts">

            <!-- HEADER -->
            <div class="invoice-header">
                <div class="left">
                    <img src="../../../assets/img/brand/red.png" alt="" width="100">
                </div>
                <div class="right" style="font-weight: bold;">
                    <h3>हिंदुस्थान प्रकाशन संस्था</h3>
                    <p>116-119, शिल्पीन सेंटर, पहिला मजला, गं. द. आंबेकर मार्ग,
                        वडाळा, मुंबई - 400 031</p>
                    <p>दूरध्वनीः 9967570531</p>
                </div>
                <div class="right" style="font-weight: bold;">
                    दिनांक: {{vitarandate}}
                </div>
            </div>

            <hr>

            <!-- TO SECTION -->
            <div class="invoice-to">
                <p class="recipient-name">प्रति : {{data.name}}</p>
                <p>{{data.address}}</p>
                <p>{{data.pincode}} {{data.taluka}}</p>
                <p>{{data.mobile}}</p>
            </div>

            <!-- TABLE -->
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>अंक संख्या</th>
                        <th>रक्कम</th>
                        <th>गणीबंडल</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{data.amount}}</td>
                        <td>{{data.amount * price}}</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>

            <!-- FOOTER -->
            <div style="text-align: end; border-bottom: 2px solid #000; margin-top: 10px;">
                <p>(अंक व विक्री विभाग)</p>
            </div>
            <p class="text-center">
                <b>मुख्य कार्यलय :</b> 12, कामत औद्योगिक वसाहत, 316, स्वा वीर सावरकर मार्ग, प्रभादेवी, मुंबई - 400025
            </p>
            <p class="text-center">E-mail : vivekwkl&#64;gmail.com • Website : www.vivek.com</p>

        </div>
    </div>
</div>